import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-icon-next-step',
  templateUrl: './icon-next-step.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconNextStepComponent {}
